import React from "react";
import { CardTitle as KendoCardTitle } from "@progress/kendo-react-layout";

/**
 * CardTitle component wrapping KendoReact CardTitle with all supported props.
 * 
 * @param {object} props
 * @param {React.ReactNode} [props.children] - CardTitle children elements.
 * @param {string} [props.className] - Additional classes for the CardTitle.
 * @param {React.CSSProperties} [props.style] - Additional CSS styles.
 * @returns {JSX.Element}
 */
export const CardTitle = ({ 
    className = '', 
    style = {}, 
    children
}) => (
  <KendoCardTitle 
    className={className} 
    style={style} 
  >
    {children}
  </KendoCardTitle>
);
